import * as React from 'react';

import * as classNames from "classnames";
import './TrialPatientsPage.scss';
import { match } from "react-router";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import { routerActions } from 'react-router-redux';
import { Location, History } from "history";
import ReactSelectClass from "react-select";
import ReactTable, { Column, RowInfo } from 'react-table';
import * as ReactTooltip from 'react-tooltip';
import Alert from 'react-s-alert';
import { DefaultLayout, RestrictedLayout, UnrestrictedLayout, SubMenu } from "../../../components/layouts/index";
import * as TrialActions from '../../../actions/trial';
import * as PatientActions from '../../../actions/patient';
import * as Dtos from '../../../dtos/Tmd.dtos';
import { ITmdState } from "../../../reducers/index";
import { RequestState } from "../../../enumerations/RequestState";
import { Link } from "../../../components/routing/index";
import { findLookup, generateOptionsFromLookup } from "../../../helpers/lookupHelper";
import { convertToShortDateString, convertToDateTimeString, convertToApproximateDateString } from "../../../helpers/date";
import { FontAwesomeIcon, FontAwesomeIcons } from "../../../constants/fontAwesomeIcons";
import { ILinkProps } from "../../../components/routing/Link";
import { INavItem } from "../../../components/layouts/NavMenu/NavMenu";
import { DEFAULT_PAGE_SIZE, PAGE_SIZE_OPTIONS } from "../../../constants/reactTableConstants";
import { setModalTitle } from "../../../helpers/modalHelper";
import { Modal, NotificationAlert, Placeholder } from "../../../components/common/index";
import * as AuthenticationHelper from '../../../helpers/authentication';
import * as AuthorisationDefinitions from '../../../constants/authorisationDefinitions';
import { ModalSize } from '../../../enumerations/ModalSize';
import { Form, actions, Control } from 'react-redux-form';
import { TextAreaFormInput } from '../../../components/form';
import { TrialSubMenu } from '../../../helpers/subMenuHelper';
import { TrialLayout } from '../../index';

interface ITrialPatientsPageParams {
    trialId: number;
}

interface ITrialPatientsPageProps {

    location: Location;
    trialId: number;
    match: match<ITrialPatientsPageParams>;
    history: History;

    // From state
    trial: Dtos.Trial;
    trialRoles: Dtos.RoleType[];
    patients: Dtos.Patient[],

    loadingTrial: boolean;
    loadTrialSuccess: boolean;
    loadTrialFailure: boolean;

    loadingPatients: boolean;
    loadPatientsSuccess: boolean;
    loadPatientsFailure: boolean;

    importingPatients: boolean;
    importPatientsSuccess: boolean;
    importPatientsFailure: boolean;

    user: Dtos.User;
    permissions?: Dtos.PersonnelTmdPermissions[];
}

interface ITrialPatientsPageActions {
    clearPatients: PatientActions.IPatientClearActionCreator;
    loadPatients: PatientActions.IPatientLoadActionCreator;

    clearTrial: TrialActions.ITrialClearActionCreator;
    loadTrial: TrialActions.ITrialLoadByIdActionCreator;

    importPatients: PatientActions.IPatientImportActionCreator;

    navigate: typeof routerActions.push;
    navigateReplace: typeof routerActions.replace;
}

type TrialPatientsPageProps = ITrialPatientsPageProps & ITrialPatientsPageActions;

const tableHeaderClass = "btn btn-primary btn-block rounded-0 p-3 d-flex"
const tableStyleClass: React.CSSProperties = {
    textAlign: "left",
    fontWeight: "bold",
    color: "white",
    cursor: "pointer"
}


class TrialPatientsPage extends React.PureComponent<TrialPatientsPageProps, any> {

    constructor(props: TrialPatientsPageProps) {
        super(props);

        this.clearPatients = this.clearPatients.bind(this);
    }

    componentDidMount() {
        const {
            loadTrial,
            loadPatients,
            navigate,
            navigateReplace,
            trialId
        } = this.props;

        loadTrial(trialId, false, false, false, false, false);
        loadPatients(trialId, 0);
    }

    componentWillReceiveProps(nextProps: TrialPatientsPageProps) {
    }

    componentDidUpdate(prevProps: TrialPatientsPageProps, prevState) {
        const {
            navigateReplace,
            loadTrial,
            trialId,
            importingPatients,
            importPatientsSuccess,
            loadPatients
        } = this.props

        if (prevProps.importingPatients && !importingPatients && importPatientsSuccess) {
            loadPatients(trialId, 0);
        }
    }

    componentWillUpdate(nextProps: TrialPatientsPageProps) {
    }

    componentWillUnmount() {
        this.clearPatients();
    }

    clearPatients() {
        this.props.clearTrial();
        this.props.clearPatients();
    }

    showPatients(): boolean {
        const {
            loadingTrial,
            loadTrialSuccess,
            loadingPatients,
            loadPatientsSuccess
        } = this.props

        console.log('showPatients', loadingTrial,
            loadTrialSuccess,
            loadingPatients,
            loadPatientsSuccess);

        if (!loadingTrial && loadTrialSuccess && !loadingPatients && loadPatientsSuccess ) {
            return true;
        }

        return false;
    }

    render() {
        const {
            loadingTrial,
            loadingPatients,
        } = this.props

        return (
            <TrialLayout loading={loadingTrial || loadingPatients} permission={Dtos.Permission.TrialPatientView}>{this.renderContent()}</TrialLayout>
        );
    }

    renderContent() {
        const {
            trial,
            trialId,
            importingPatients,
            importPatients,
            permissions
        } = this.props;

        const canImport =( AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialPatientCreate, trialId, null) && trial && trial.id);
        
        return <div>
            <div className="row">
                <div className={"col-auto mb-2"}>
                    <h2>Trial Participants</h2>
                </div>
                <div className="col" style={{ textAlign: 'right' }}>
                    {canImport && (
                        <button
                            className={"btn btn-warning"}
                            onClick={() => importPatients(trial.id)}
                            disabled={importingPatients || !trial.patientImportConfigured}>
                            {importingPatients ? "Importing..." : "Import from OpenClinica"}
                        </button>
                    )}
                    {(AuthenticationHelper.hasPermission(permissions, Dtos.Permission.TrialPatientCreate, trialId, null) && trial && trial.id > 0) && (
                        <Link className={"btn btn-primary ml-2"} url={"/trials/" + trial.id + "/participants/create"}>Add Participant</Link>
                    )}
                </div>
            </div>
            {(canImport && !trial.patientImportConfigured) && <div className="row">
                <div className="col">
                    <div className="alert alert-info d-flex">
                       <span>Import from OpenClinica is not configured, contact NewtonGreen</span>
                    </div>
                </div>
            </div>}
            {
                !this.showPatients() ?
                    "Loading Participants" :
                    null
            }
            {
                this.showPatients() ?
                    <div className="patient-tables mt-2">
                        {
                            this.createTable()
                        }
                    </div> :
                    null
            }
        </div>
    }


    createTable() {

        const {
            trial,
            patients
        } = this.props

        if (!patients || patients.length == 0) {
            return <div className="alert alert-info d-flex">
                <div className="mr-2">
                    <FontAwesomeIcon icon={FontAwesomeIcons.Solid.INFO_SQUARE} fixedWidth />
                </div>
                <span>There are currently no participants</span>
            </div>
        }

        const showPagination = patients.length > DEFAULT_PAGE_SIZE;

        return <div className="table-wrapper mb-3">
            <ReactTable
                data={patients}
                pageSizeOptions={PAGE_SIZE_OPTIONS}
                defaultPageSize={showPagination ? DEFAULT_PAGE_SIZE : patients.length}
                pageSize={showPagination ? undefined : patients.length}
                showPagination={showPagination}
                className="-striped -highlight -clickable mb-3"
                noDataText="There are currently no patients to display"
                resizable={false}
                getTdProps={(state, rowInfo: RowInfo, column, instance) => {
                    return {
                        onClick: (e, handleOriginal) => {

                            const url: string = "/trials/" + trial.id + "/participants/" + rowInfo.original.id;
                            this.props.navigate(url);
                            if (handleOriginal) {
                                handleOriginal()
                            }

                        }
                    }
                }}
                columns={[
                    {
                        id: "opmsId",
                        Header: ' ',
                        accessor: "opmsId",
                        className: "d-flex align-items-center justify-content-center",
                        maxWidth: 50,
                        Cell: (props) => <FontAwesomeIcon icon={props.value > 0 ? FontAwesomeIcons.Light.USER : FontAwesomeIcons.Light.USEREDIT} fixedWidth />
                    },
                    {
                        id: "registrationNumber",
                        Header: 'Registration No.',
                        accessor: 'registrationNumber',
                        className: "d-flex align-items-left justify-content-left",
                        headerClassName: "text-left",
                        maxWidth: 160
                    },
                    {
                        id: "initials",
                        Header: 'Initials',
                        accessor: 'initials',
                        className: "d-flex align-items-left justify-content-left",
                        headerClassName: "text-left",
                        maxWidth: 90
                    },
                    {
                        id: "caseType",
                        Header: 'Case Type',
                        accessor: 'caseType.value',
                        className: "d-flex align-items-left justify-content-left",
                        headerClassName: "text-left"
                    },
                    {
                        id: "treatment",
                        Header: 'Treatment',
                        accessor: 'trialTreatment.name',
                        className: "d-flex align-items-left justify-content-left",
                        headerClassName: "text-left"
                    },
                    {
                        id: "institution",
                        Header: 'Institution',
                        accessor: 'institution.name',
                        className: "d-flex align-items-left justify-content-left",
                        headerClassName: "text-left"
                    },
                    {
                        id: "code",
                        Header: 'Code',
                        accessor: 'institution.code',
                        className: "d-flex align-items-left justify-content-left",
                        headerClassName: "text-left",
                        maxWidth: 100
                    },
                ]}
            />
        </div>

    }

}


const mapStateToProps = (state: ITmdState, ownProps: TrialPatientsPageProps): ITrialPatientsPageProps => {

    let trial: Dtos.Trial | undefined = !(state.trials.formData instanceof Array) ? state.trials.formData : undefined;
    let patients: Dtos.Patient[] | undefined = (state.patient.formData instanceof Array) ? state.patient.formData : undefined;
    let permissions = state.user.userSummary ? state.user.userSummary.permissions : [];

    return {

        match: ownProps.match,
        trialId: ownProps.match ? ownProps.match.params.trialId : undefined!,

        history: ownProps.history,
        location: state.routing.location,

        trial: trial!,
        trialRoles: state.trials.formRoles,
        patients: patients!,

        loadingPatients: state.patient.loadState && state.patient.loadState.status == RequestState.Pending,
        loadPatientsSuccess: state.patient.loadState && state.patient.loadState.status == RequestState.Success,
        loadPatientsFailure: state.patient.loadState && state.patient.loadState.status == RequestState.Failure,

        loadingTrial: state.trials.loadState && state.trials.loadState.status == RequestState.Pending,
        loadTrialSuccess: state.trials.loadState && state.trials.loadState.status == RequestState.Success,
        loadTrialFailure: state.trials.loadState && state.trials.loadState.status == RequestState.Failure,

        importingPatients: state.patient.importState && state.patient.importState.status == RequestState.Pending,
        importPatientsSuccess: state.patient.importState && state.patient.importState.status == RequestState.Success,
        importPatientsFailure: state.patient.importState && state.patient.importState.status == RequestState.Failure,

        user: state.user.data,
        permissions: permissions,
    };
};

const mapDispatchToProps = (dispatch): ITrialPatientsPageActions => {
    return {
        navigate: bindActionCreators(routerActions.push, dispatch),
        navigateReplace: bindActionCreators(routerActions.replace, dispatch),

        loadPatients: bindActionCreators(PatientActions.LoadPatient, dispatch),
        clearPatients: bindActionCreators(PatientActions.Clear, dispatch),

        importPatients: bindActionCreators(PatientActions.Import, dispatch),

        loadTrial: bindActionCreators(TrialActions.LoadTrialById, dispatch),
        clearTrial: bindActionCreators(TrialActions.Clear, dispatch)
    };
};

export default
    connect(mapStateToProps, mapDispatchToProps)(TrialPatientsPage);
